import Domains from '../global/constants/domain.ts';

export const loadDomainSpecificCSS = () => {
    
      import('../assets/common/css/style.css').catch((err) => {
        console.error("Error loading default CSS", err);
      });
  };
  